// AUTO-GENERATED by .tmp-codemod/generate-registry-ts.js -- do not hand-edit the icon
// lists below without regenerating; add/remove icons here and re-run the codemod
// instead. Each icon is imported individually (not as a whole style pack) so the
// production bundle only ships the glyphs meplis-cnp actually renders.
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRightFromBracket as faArrowRightFromBracketSolid,
  faBolt as faBoltSolid,
  faCalendar as faCalendarSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCircle as faCircleSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleExclamation as faCircleExclamationSolid,
  faCirclePlay as faCirclePlaySolid,
  faCircleUser as faCircleUserSolid,
  faCloudArrowUp as faCloudArrowUpSolid,
  faDownload as faDownloadSolid,
  faEye as faEyeSolid,
  faFile as faFileSolid,
  faFlask as faFlaskSolid,
  faGlobe as faGlobeSolid,
  faLocationDot as faLocationDotSolid,
  faMessage as faMessageSolid,
  faNotesMedical as faNotesMedicalSolid,
  faRotate as faRotateSolid,
  faStethoscope as faStethoscopeSolid,
  faUpload as faUploadSolid,
  faUserDoctor as faUserDoctorSolid,
  faUsers as faUsersSolid,
  faVideo as faVideoSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCalendarDays as faCalendarDaysRegular,
  faClockRotateLeft as faClockRotateLeftRegular,
  faMagnifyingGlass as faMagnifyingGlassRegular,
  faNotesMedical as faNotesMedicalRegular,
  faUsers as faUsersRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDown as faArrowDownSharpSolid,
  faQrcode as faQrcodeSharpSolid,
  faLaptopMobile as faLaptopMobileSharpSolid,
  faMobileScreen as faMobileScreenSharpSolid,
  faArrowDownAZ as faArrowDownAZSharpSolid,
  faArrowDownZA as faArrowDownZASharpSolid,
  faArrowLeft as faArrowLeftSharpSolid,
  faArrowRightFromBracket as faArrowRightFromBracketSharpSolid,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareSharpSolid,
  faAt as faAtSharpSolid,
  faBan as faBanSharpSolid,
  faBars as faBarsSharpSolid,
  faBell as faBellSharpSolid,
  faBolt as faBoltSharpSolid,
  faBookmark as faBookmarkSharpSolid,
  faBookOpen as faBookOpenSharpSolid,
  faBriefcaseMedical as faBriefcaseMedicalSharpSolid,
  faCalendar as faCalendarSharpSolid,
  faCalendarCheck as faCalendarCheckSharpSolid,
  faCalendarDays as faCalendarDaysSharpSolid,
  faCamera as faCameraSharpSolid,
  faCheck as faCheckSharpSolid,
  faChevronDown as faChevronDownSharpSolid,
  faChevronLeft as faChevronLeftSharpSolid,
  faChevronRight as faChevronRightSharpSolid,
  faChevronUp as faChevronUpSharpSolid,
  faCircleCheck as faCircleCheckSharpSolid,
  faCircleDot as faCircleDotSharpSolid,
  faCircleExclamation as faCircleExclamationSharpSolid,
  faCircleInfo as faCircleInfoSharpSolid,
  faCircleQuestion as faCircleQuestionSharpSolid,
  faCirclePlay as faCirclePlaySharpSolid,
  faClipboardCheck as faClipboardCheckSharpSolid,
  faClock as faClockSharpSolid,
  faClockRotateLeft as faClockRotateLeftSharpSolid,
  faCloudArrowUp as faCloudArrowUpSharpSolid,
  faComment as faCommentSharpSolid,
  faCommentDots as faCommentDotsSharpSolid,
  faComments as faCommentsSharpSolid,
  faCopy as faCopySharpSolid,
  faDesktop as faDesktopSharpSolid,
  faDownload as faDownloadSharpSolid,
  faEllipsis as faEllipsisSharpSolid,
  faEllipsisVertical as faEllipsisVerticalSharpSolid,
  faEnvelope as faEnvelopeSharpSolid,
  faEye as faEyeSharpSolid,
  faEyeSlash as faEyeSlashSharpSolid,
  faFaceLaugh as faFaceLaughSharpSolid,
  faFile as faFileSharpSolid,
  faFileArrowUp as faFileArrowUpSharpSolid,
  faFileCertificate as faFileCertificateSharpSolid,
  faFileCsv as faFileCsvSharpSolid,
  faFileExcel as faFileExcelSharpSolid,
  faFileLines as faFileLinesSharpSolid,
  faFilePdf as faFilePdfSharpSolid,
  faFilePowerpoint as faFilePowerpointSharpSolid,
  faFileWord as faFileWordSharpSolid,
  faFileZipper as faFileZipperSharpSolid,
  faFlask as faFlaskSharpSolid,
  faFolder as faFolderSharpSolid,
  faFolderOpen as faFolderOpenSharpSolid,
  faFolderPlus as faFolderPlusSharpSolid,
  faGlobe as faGlobeSharpSolid,
  faGraduationCap as faGraduationCapSharpSolid,
  faHandHoldingHeart as faHandHoldingHeartSharpSolid,
  faHeart as faHeartSharpSolid,
  faHeartPulse as faHeartPulseSharpSolid,
  faHourglassStart as faHourglassStartSharpSolid,
  faHouse as faHouseSharpSolid,
  faImage as faImageSharpSolid,
  faImages as faImagesSharpSolid,
  faLayerGroup as faLayerGroupSharpSolid,
  faLightbulb as faLightbulbSharpSolid,
  faListUl as faListUlSharpSolid,
  faLocationDot as faLocationDotSharpSolid,
  faLock as faLockSharpSolid,
  faLockOpen as faLockOpenSharpSolid,
  faMessage as faMessageSharpSolid,
  faMicrophone as faMicrophoneSharpSolid,
  faMicrophoneSlash as faMicrophoneSlashSharpSolid,
  faNewspaper as faNewspaperSharpSolid,
  faPaperPlane as faPaperPlaneSharpSolid,
  faPaperclip as faPaperclipSharpSolid,
  faPen as faPenSharpSolid,
  faPenToSquare as faPenToSquareSharpSolid,
  faPeopleGroup as faPeopleGroupSharpSolid,
  faPhoneSlash as faPhoneSlashSharpSolid,
  faPlay as faPlaySharpSolid,
  faPlus as faPlusSharpSolid,
  faRepeat as faRepeatSharpSolid,
  faRightFromBracket as faRightFromBracketSharpSolid,
  faRightToBracket as faRightToBracketSharpSolid,
  faRotate as faRotateSharpSolid,
  faRotateRight as faRotateRightSharpSolid,
  faRoute as faRouteSharpSolid,
  faRss as faRssSharpSolid,
  faShare as faShareSharpSolid,
  faSliders as faSlidersSharpSolid,
  faSpinner as faSpinnerSharpSolid,
  faSquareCheck as faSquareCheckSharpSolid,
  faStop as faStopSharpSolid,
  faThumbsUp as faThumbsUpSharpSolid,
  faTicket as faTicketSharpSolid,
  faTrash as faTrashSharpSolid,
  faUpload as faUploadSharpSolid,
  faUser as faUserSharpSolid,
  faUserMinus as faUserMinusSharpSolid,
  faUserPlus as faUserPlusSharpSolid,
  faUsers as faUsersSharpSolid,
  faVideo as faVideoSharpSolid,
  faVideoSlash as faVideoSlashSharpSolid,
  faWandMagicSparkles as faWandMagicSparklesSharpSolid,
  faXmark as faXmarkSharpSolid,
  faStar as faStarSharpSolid,
} from '@fortawesome/sharp-solid-svg-icons';
import {
  faArrowLeft as faArrowLeftSharpRegular,
  faArrowRight as faArrowRightSharpRegular,
  faBriefcase as faBriefcaseSharpRegular,
  faBriefcaseMedical as faBriefcaseMedicalSharpRegular,
  faBuilding as faBuildingSharpRegular,
  faCalendar as faCalendarSharpRegular,
  faCalendarCheck as faCalendarCheckSharpRegular,
  faCalendarDay as faCalendarDaySharpRegular,
  faCalendarDays as faCalendarDaysSharpRegular,
  faCircleCheck as faCircleCheckSharpRegular,
  faClipboardCheck as faClipboardCheckSharpRegular,
  faCircleExclamation as faCircleExclamationSharpRegular,
  faCirclePlay as faCirclePlaySharpRegular,
  faClock as faClockSharpRegular,
  faCommentDots as faCommentDotsSharpRegular,
  faCompass as faCompassSharpRegular,
  faEnvelope as faEnvelopeSharpRegular,
  faFileLines as faFileLinesSharpRegular,
  faFolderOpen as faFolderOpenSharpRegular,
  faGraduationCap as faGraduationCapSharpRegular,
  faGrid2 as faGrid2SharpRegular,
  faHandshake as faHandshakeSharpRegular,
  faHourglassStart as faHourglassStartSharpRegular,
  faImage as faImageSharpRegular,
  faInbox as faInboxSharpRegular,
  faLinkSlash as faLinkSlashSharpRegular,
  faListCheck as faListCheckSharpRegular,
  faLocationDot as faLocationDotSharpRegular,
  faLock as faLockSharpRegular,
  faMagnifyingGlass as faMagnifyingGlassSharpRegular,
  faMapLocationDot as faMapLocationDotSharpRegular,
  faMicrophone as faMicrophoneSharpRegular,
  faMoneyBill as faMoneyBillSharpRegular,
  faNewspaper as faNewspaperSharpRegular,
  faNotesMedical as faNotesMedicalSharpRegular,
  faPaperclip as faPaperclipSharpRegular,
  faPenToSquare as faPenToSquareSharpRegular,
  faRectangleList as faRectangleListSharpRegular,
  faRotateLeft as faRotateLeftSharpRegular,
  faShield as faShieldSharpRegular,
  faStethoscope as faStethoscopeSharpRegular,
  faTag as faTagSharpRegular,
  faTicket as faTicketSharpRegular,
  faTrash as faTrashSharpRegular,
  faUserDoctorMessage as faUserDoctorMessageSharpRegular,
  faUserGroup as faUserGroupSharpRegular,
  faUsers as faUsersSharpRegular,
  faUsersRectangle as faUsersRectangleSharpRegular,
  faVideo as faVideoSharpRegular,
  faStar as faStarSharpRegular,
} from '@fortawesome/sharp-regular-svg-icons';
import {
  faFacebook as faFacebookBrand,
  faGoogle as faGoogleBrand,
  faLinkedin as faLinkedinBrand,
  faLinkedinIn as faLinkedinInBrand,
} from '@fortawesome/free-brands-svg-icons';

/**
 * Every Font Awesome icon used anywhere in meplis-cnp, registered once with
 * {@link FaIconLibrary.addIcons} in `app.config.ts`. Templates then reference
 * icons by `[prefix, name]` tuple (e.g. `['fass', 'house']`) via `<fa-icon>`,
 * or through the `faIconName` pipe for icon names coming from data/config.
 */
export const MEPLIS_ICONS: IconDefinition[] = [
  faArrowRightFromBracketSolid,
  faBoltSolid,
  faCalendarSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faCircleSolid,
  faCircleCheckSolid,
  faCircleExclamationSolid,
  faCirclePlaySolid,
  faCircleUserSolid,
  faCloudArrowUpSolid,
  faDownloadSolid,
  faEyeSolid,
  faFileSolid,
  faFlaskSolid,
  faGlobeSolid,
  faLocationDotSolid,
  faMessageSolid,
  faNotesMedicalSolid,
  faRotateSolid,
  faStethoscopeSolid,
  faUploadSolid,
  faUserDoctorSolid,
  faUsersSolid,
  faVideoSolid,
  faCalendarDaysRegular,
  faClockRotateLeftRegular,
  faMagnifyingGlassRegular,
  faNotesMedicalRegular,
  faUsersRegular,
  faArrowDownSharpSolid,
  faQrcodeSharpSolid,
  faLaptopMobileSharpSolid,
  faMobileScreenSharpSolid,
  faArrowDownAZSharpSolid,
  faArrowDownZASharpSolid,
  faArrowLeftSharpSolid,
  faArrowUpRightFromSquareSharpSolid,
  faAtSharpSolid,
  faBanSharpSolid,
  faBarsSharpSolid,
  faBellSharpSolid,
  faBoltSharpSolid,
  faBookOpenSharpSolid,
  faBookmarkSharpSolid,
  faBriefcaseMedicalSharpSolid,
  faCalendarSharpSolid,
  faCalendarCheckSharpSolid,
  faCalendarDaysSharpSolid,
  faCameraSharpSolid,
  faCheckSharpSolid,
  faChevronDownSharpSolid,
  faChevronLeftSharpSolid,
  faChevronRightSharpSolid,
  faChevronUpSharpSolid,
  faCircleCheckSharpSolid,
  faCircleDotSharpSolid,
  faCircleExclamationSharpSolid,
  faCircleInfoSharpSolid,
  faCircleQuestionSharpSolid,
  faCirclePlaySharpSolid,
  faClipboardCheckSharpSolid,
  faClockSharpSolid,
  faClockRotateLeftSharpSolid,
  faCloudArrowUpSharpSolid,
  faCommentSharpSolid,
  faCommentDotsSharpSolid,
  faCommentsSharpSolid,
  faPenSharpSolid,
  faPaperPlaneSharpSolid,
  faPaperclipSharpSolid,
  faLockSharpSolid,
  faArrowRightFromBracketSharpSolid,
  faCopySharpSolid,
  faDesktopSharpSolid,
  faDownloadSharpSolid,
  faEllipsisSharpSolid,
  faEllipsisVerticalSharpSolid,
  faEnvelopeSharpSolid,
  faEyeSharpSolid,
  faEyeSlashSharpSolid,
  faFaceLaughSharpSolid,
  faFileSharpSolid,
  faFileArrowUpSharpSolid,
  faFileCertificateSharpSolid,
  faFileCsvSharpSolid,
  faFileExcelSharpSolid,
  faFileLinesSharpSolid,
  faFilePdfSharpSolid,
  faFilePowerpointSharpSolid,
  faFileWordSharpSolid,
  faFileZipperSharpSolid,
  faFlaskSharpSolid,
  faFolderSharpSolid,
  faFolderOpenSharpSolid,
  faFolderPlusSharpSolid,
  faGlobeSharpSolid,
  faGraduationCapSharpSolid,
  faHandHoldingHeartSharpSolid,
  faHeartSharpSolid,
  faHeartPulseSharpSolid,
  faHourglassStartSharpSolid,
  faHouseSharpSolid,
  faImageSharpSolid,
  faImagesSharpSolid,
  faLayerGroupSharpSolid,
  faLightbulbSharpSolid,
  faListUlSharpSolid,
  faLocationDotSharpSolid,
  faLockOpenSharpSolid,
  faMessageSharpSolid,
  faMicrophoneSharpSolid,
  faMicrophoneSlashSharpSolid,
  faNewspaperSharpSolid,
  faPeopleGroupSharpSolid,
  faPenToSquareSharpSolid,
  faPhoneSlashSharpSolid,
  faPlaySharpSolid,
  faPlusSharpSolid,
  faRepeatSharpSolid,
  faRightFromBracketSharpSolid,
  faRightToBracketSharpSolid,
  faRotateSharpSolid,
  faRotateRightSharpSolid,
  faRouteSharpSolid,
  faRssSharpSolid,
  faShareSharpSolid,
  faSlidersSharpSolid,
  faSpinnerSharpSolid,
  faSquareCheckSharpSolid,
  faStopSharpSolid,
  faThumbsUpSharpSolid,
  faTicketSharpSolid,
  faTrashSharpSolid,
  faUploadSharpSolid,
  faUserSharpSolid,
  faUserMinusSharpSolid,
  faUserPlusSharpSolid,
  faUsersSharpSolid,
  faVideoSharpSolid,
  faVideoSlashSharpSolid,
  faWandMagicSparklesSharpSolid,
  faXmarkSharpSolid,
  faArrowLeftSharpRegular,
  faArrowRightSharpRegular,
  faBriefcaseSharpRegular,
  faBriefcaseMedicalSharpRegular,
  faBuildingSharpRegular,
  faCalendarSharpRegular,
  faCalendarCheckSharpRegular,
  faCalendarDaySharpRegular,
  faCalendarDaysSharpRegular,
  faCircleCheckSharpRegular,
  faClipboardCheckSharpRegular,
  faCircleExclamationSharpRegular,
  faCirclePlaySharpRegular,
  faClockSharpRegular,
  faCommentDotsSharpRegular,
  faCompassSharpRegular,
  faEnvelopeSharpRegular,
  faFileLinesSharpRegular,
  faFolderOpenSharpRegular,
  faGraduationCapSharpRegular,
  faGrid2SharpRegular,
  faHandshakeSharpRegular,
  faHourglassStartSharpRegular,
  faImageSharpRegular,
  faInboxSharpRegular,
  faLinkSlashSharpRegular,
  faListCheckSharpRegular,
  faLocationDotSharpRegular,
  faLockSharpRegular,
  faMagnifyingGlassSharpRegular,
  faMapLocationDotSharpRegular,
  faMicrophoneSharpRegular,
  faMoneyBillSharpRegular,
  faNewspaperSharpRegular,
  faNotesMedicalSharpRegular,
  faPaperclipSharpRegular,
  faPenToSquareSharpRegular,
  faRectangleListSharpRegular,
  faRotateLeftSharpRegular,
  faShieldSharpRegular,
  faStethoscopeSharpRegular,
  faTagSharpRegular,
  faTicketSharpRegular,
  faTrashSharpRegular,
  faUserDoctorMessageSharpRegular,
  faUserGroupSharpRegular,
  faUsersSharpRegular,
  faUsersRectangleSharpRegular,
  faVideoSharpRegular,
  faFacebookBrand,
  faGoogleBrand,
  faLinkedinBrand,
  faLinkedinInBrand,
  faStarSharpSolid,
  faStarSharpRegular,
];
